import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Products } from "./pages/Products";
import { Gallery } from "./pages/Gallery";
import { Reviews } from "./pages/Reviews";
import { Contact } from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

// Admin imports
import { AuthProvider, useAuth } from "./admin/AdminContext";
import { AdminLayout } from "./admin/AdminLayout";
import { AdminLogin } from "./admin/pages/AdminLogin";
import { Dashboard } from "./admin/pages/Dashboard";
import { ServicesManager } from "./admin/pages/ServicesManager";
import { ProductsManager } from "./admin/pages/ProductsManager";
import { ProjectsManager } from "./admin/pages/ProjectsManager";
import { ReviewsManager } from "./admin/pages/ReviewsManager";
import { OffersManager } from "./admin/pages/OffersManager";
import { EnquiriesManager } from "./admin/pages/EnquiriesManager";
import { HomepageManager } from "./admin/pages/HomepageManager";
import { AboutManager } from "./admin/pages/AboutManager";
import { ContactManager } from "./admin/pages/ContactManager";
import { BrandingManager } from "./admin/pages/BrandingManager";
import { SEOManager } from "./admin/pages/SEOManager";
import { UsersManager } from "./admin/pages/UsersManager";
import { SettingsManager } from "./admin/pages/SettingsManager";
import { CategoriesManager } from "./admin/pages/CategoriesManager";
import { ReelsManager } from "./admin/pages/ReelsManager";
import { ClientLogosManager } from "./admin/pages/ClientLogosManager";
import { ImageUploadDemo } from "./admin/pages/ImageUploadDemo";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="w-8 h-8 border-4 border-sky-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return <AdminLayout>{children}</AdminLayout>;
};

// Admin Routes Component
const AdminRoutes = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route path="" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="homepage" element={<ProtectedRoute><HomepageManager /></ProtectedRoute>} />
        <Route path="about" element={<ProtectedRoute><AboutManager /></ProtectedRoute>} />
        <Route path="categories" element={<ProtectedRoute><CategoriesManager /></ProtectedRoute>} />
        <Route path="services" element={<ProtectedRoute><ServicesManager /></ProtectedRoute>} />
        <Route path="products" element={<ProtectedRoute><ProductsManager /></ProtectedRoute>} />
        <Route path="projects" element={<ProtectedRoute><ProjectsManager /></ProtectedRoute>} />
        <Route path="reels" element={<ProtectedRoute><ReelsManager /></ProtectedRoute>} />
        <Route path="reviews" element={<ProtectedRoute><ReviewsManager /></ProtectedRoute>} />
        <Route path="client-logos" element={<ProtectedRoute><ClientLogosManager /></ProtectedRoute>} />
        <Route path="offers" element={<ProtectedRoute><OffersManager /></ProtectedRoute>} />
        <Route path="image-upload" element={<ProtectedRoute><ImageUploadDemo /></ProtectedRoute>} />
        <Route path="enquiries" element={<ProtectedRoute><EnquiriesManager /></ProtectedRoute>} />
        <Route path="contact" element={<ProtectedRoute><ContactManager /></ProtectedRoute>} />
        <Route path="branding" element={<ProtectedRoute><BrandingManager /></ProtectedRoute>} />
        <Route path="seo" element={<ProtectedRoute><SEOManager /></ProtectedRoute>} />
        <Route path="users" element={<ProtectedRoute><UsersManager /></ProtectedRoute>} />
        <Route path="settings" element={<ProtectedRoute><SettingsManager /></ProtectedRoute>} />
      </Routes>
    </AuthProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/*" element={<><AdminRoutes /><Toaster position="top-right" /></>} />
          
          {/* Public Routes with Layout */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/products" element={<Layout><Products /></Layout>} />
          <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
          <Route path="/reviews" element={<Layout><Reviews /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
